import {
    Pencil,
    Save,
    RotateCcw,
    Trash2,
    Check,
    User,
    UserPlus,
    Users,
    UserCheck,
    MapPin,
    MapPinPlus,
    Search,
    Calendar,
    CalendarPlus,
    History,
    Clock,
    ListPlus,
    ClipboardList,
    Printer,
    FileText,
    Settings,
    Info,
    Circle,
    Banknote,
    Mail,
    MailCheck,
    Puzzle,
    ThumbsDown,
    ChevronsLeft,
    Send,
    Truck,
    PlusCircle,
    FileX,
    FileSpreadsheet,
    ChevronRight,
    MessageSquare,
    Package,
    PackagePlus,
    PackageCheck,
    Car,
    Camera,
    Route,
    AlertCircle,
    Plus,
    X,
    ShieldOff,
    type LucideIconData,
} from 'lucide-angular';

// Re-export all icons for easy importing
export {
    Pencil,
    Save,
    RotateCcw,
    Trash2,
    Check,
    User,
    UserPlus,
    Users,
    UserCheck,
    MapPin,
    MapPinPlus,
    Search,
    Calendar,
    CalendarPlus,
    History,
    Clock,
    ListPlus,
    ClipboardList,
    Printer,
    FileText,
    Settings,
    Info,
    Circle,
    Banknote,
    Mail,
    MailCheck,
    Puzzle,
    ThumbsDown,
    ChevronsLeft,
    Send,
    Truck,
    PlusCircle,
    FileX,
    FileSpreadsheet,
    ChevronRight,
    MessageSquare,
    Package,
    PackagePlus,
    PackageCheck,
    Car,
    Camera,
    Route,
    AlertCircle,
    Plus,
    X,
    ShieldOff,
    type LucideIconData,
};

// Icon mapping from old PNG names to Lucide icons
export const ICON_MAP: Record<string, LucideIconData> = {
    edit_list: Pencil,
    save: Save,
    undo: RotateCcw,
    trashcan_open: Trash2,
    check: Check,
    check_click_green: Check,
    check_click_gray: Check,
    user: User,
    user_add: UserPlus,
    user_list: Users,
    user_group: Users,
    user_ok: UserCheck,
    location: MapPin,
    location_add: MapPinPlus,
    glass: Search,
    event: Calendar,
    event_add: CalendarPlus,
    event_history: History,
    date_time: Clock,
    add_list: ListPlus,
    clipboard: ClipboardList,
    printer: Printer,
    printer_gray: Printer,
    pdf_logo: FileText,
    setting: Settings,
    icon_info_round_blue: Info,
    icon_info_round_gray: Info,
    red_round: Circle,
    yellow_round: Circle,
    orange_round: Circle,
    green_round: Circle,
    gray_round: Circle,
    cash: Banknote,
    cash_green: Banknote,
    mail: Mail,
    mail_ok: MailCheck,
    puzzle_blue_changed: Puzzle,
    puzzle_blue_delete: Puzzle,
    red_thumb_down: ThumbsDown,
    move_all_left: ChevronsLeft,
    list_send: Send,
    truck_blue: Truck,
    truck_blue_add: Truck,
    truck_blue_block: Truck,
    truck_yellow_order: Truck,
    add_sign_blue: PlusCircle,
    document_missing: FileX,
    excel_logo: FileSpreadsheet,
    arrow_enum_right_blue: ChevronRight,
    speech_bubble_right: MessageSquare,
    container_blue: Package,
    container_blue_add: PackagePlus,
    box_confirmed: PackageCheck,
    box_request: Package,
    van_gray: Car,
    camera: Camera,
    tour_logo: Route,
    menu_error: AlertCircle,
};

// Color classes for icons that need specific colors
export const ICON_COLORS: Record<string, string> = {
    printer_gray: 'text-gray-400',
    icon_info_round_blue: 'text-blue-500',
    icon_info_round_gray: 'text-gray-400',
    red_round: 'text-red-500 fill-red-500',
    yellow_round: 'text-yellow-500 fill-yellow-500',
    orange_round: 'text-orange-500 fill-orange-500',
    green_round: 'text-green-500 fill-green-500',
    gray_round: 'text-gray-400 fill-gray-400',
    cash_green: 'text-green-500',
    puzzle_blue_changed: 'text-blue-500',
    puzzle_blue_delete: 'text-blue-500',
    red_thumb_down: 'text-red-500',
    truck_blue: 'text-blue-500',
    truck_blue_add: 'text-blue-500',
    truck_blue_block: 'text-blue-500',
    truck_yellow_order: 'text-yellow-500',
    add_sign_blue: 'text-blue-500',
    arrow_enum_right_blue: 'text-blue-500',
    container_blue: 'text-blue-500',
    container_blue_add: 'text-blue-500',
    van_gray: 'text-gray-400',
    check_click_green: 'text-green-500',
    check_click_gray: 'text-gray-400',
};

// Helper function to extract base name from PNG path
function extractBaseName(pngName: string): string {
    return pngName
        .replace(/_\d+\.png$/, '')
        .replace(/\.png$/, '')
        .replace(/^\/?(img\/common\/|img\/store\/|img\/transport\/|hd\/images\/)/, '');
}

// Helper function to get icon by old PNG name
export function getIconByName(pngName: string): LucideIconData | undefined {
    return ICON_MAP[extractBaseName(pngName)];
}

// Helper function to get color class by old PNG name
export function getIconColorClass(pngName: string): string {
    return ICON_COLORS[extractBaseName(pngName)] || '';
}
